/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'status_vendor': {
    width: 7,
    height: 8,
    viewBox: '0 0 7 8',
    data: '<path pid="0" d="M2.24 2.026l1.34 4.03h.05l1.4-4.33-.61-.04v-.85h2.3v.81l-.33.03c-.087.007-.15.032-.19.075a.713.713 0 0 0-.12.225l-1.89 5.51h-1.3L.85 1.716l-.57-.03v-.85h2.58v.81l-.33.03c-.207.014-.31.094-.31.24 0 .034.007.07.02.11z" fill-rule="nonzero"/>'
  }
})
